<!--
    ShowTestsDetailed.vue
    Component to show a more detailed preview of the test.
    by Guy E. White <guw968@g.harvard.edu>
-->
<template>
    <router-link data-test='test-link' :to='{ name:"test", params: { slug: test.slug }}'>
    <div class='test'>
            <div data-test='test-name' class='test-name'>{{ test.testName }}</div>
            <div data-test='test-description-one-sentence' class='test-description-one-sentence'>{{ test.oneSentenceDescription }}</div>
    </div>
    </router-link>
</template>

<script>
export default {
    name: '',
    props: ['test'],
    data: function() {
        return {};
    }
};
</script>

<style scoped>
</style>
